import script from "./SharedBetslipInputModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedBetslipInputModal.vue?vue&type=script&setup=true&lang=js"

import "./SharedBetslipInputModal.vue?vue&type=style&index=0&id=55b13dde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b13dde"]])

export default __exports__